import { render, staticRenderFns } from "./publishHomeworkMain.vue?vue&type=template&id=03ab2493&scoped=true"
import script from "./publishHomeworkMain.vue?vue&type=script&lang=js"
export * from "./publishHomeworkMain.vue?vue&type=script&lang=js"
import style0 from "./publishHomeworkMain.vue?vue&type=style&index=0&id=03ab2493&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ab2493",
  null
  
)

export default component.exports